import { connect } from 'react-redux'

import { selectQueryBase } from 'ducks/reports/controls'
import { selectAccountPreferenceCustomerRatingsInstalled } from 'selectors/app/selectAccountPreferences'

import PageView from './PageView'

const select = state => ({
  queryBase: selectQueryBase(state),
  isEmpty: !selectAccountPreferenceCustomerRatingsInstalled(state),
})

export default connect(select)(PageView)
